import React from "react";
import classes from "./AnswersList.module.css";
import AnswerItem from "./AnswerItem/AnwerItem";

const AnswersList = props => {
  return (
    <ul className={classes.AnswersList}>
      {props.answers.map((answer, index) => {
        return (
          <AnswerItem
            answerState={
              props.answerState ? props.answerState[answer.id] : null
            }
            onAnswerClick={props.onAnswerClick}
            key={index}
            answer={answer}
          />
        );
      })}
    </ul>
  );
};

export default AnswersList;
